<template>
    <MainView></MainView>
</template>

<script>
import MainView from '@/components/MainView.vue';
export default {
  components: {
    MainView,
  },

}
</script>

<style>

</style>